import gsap from 'gsap';
import {
	ScrollTrigger,
} from 'gsap/ScrollTrigger.js';

const animator = (() => {
	function init() {
		window.addEventListener('load', () => {
			gsap.registerPlugin(ScrollTrigger);

			// Animate all Items with the class of .animate
			gsap.from(".circle-animate-on-start", {
				scale: 0,
				duration: 1,
				stagger: {
					ease: "power2.inOut",
					from: "center",
					amount: 0.2,
				}
			});

			// Animate all Items with the class of .animate
			const animateItems = document.querySelectorAll('.circle-animate');

			animateItems.forEach((item) => {
				gsap.from(item, {
					scrollTrigger: {
						trigger: item,
						scrub: true,
						start: 'top bottom',
						end: 'top top+=20%',
					},
					scale: 0,
				});
			});
		});
	}

	return {
		init,
	};
})();

export default animator;